module.exports = __webpack_public_path__ + "img/HTML.4ab3b1a2.png";